<template>
    <div class="partner">
        <div class="header_btn">
            <el-button type="primary" :icon="Plus" @click="addPartner">添加</el-button>
        </div>
        <div class="count">统计：{{ count }}条</div>

        <el-table :data="filterTableData" style="width: 100%" row-key="unionId" border
            :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts" v-loading="showLoading">
            <!-- 合作方名称   -->
            <el-table-column fixed label="合作方名称  " prop="partnerName" align="center" :show-overflow-tooltip='true'
                width="150">
            </el-table-column>
            <!-- 合作方简称  -->
            <el-table-column label="合作方简称 " prop="abbreviation" align="center" :show-overflow-tooltip='true'
                width="150">
            </el-table-column>
            <!-- 联系人姓名  -->
            <el-table-column label="联系人姓名 " prop="contacts" align="center" :show-overflow-tooltip='true' width="150">
            </el-table-column>
            <!-- 合作方类型 -->
            <el-table-column label="合作方类型" prop="type" align="center" :show-overflow-tooltip='true' width="150">
                <template #default="scope">
                    <span v-show="scope.row.type == 1">API对接</span>
                    <span v-show="scope.row.type == 2">店铺合作方</span>
                    <span v-show="scope.row.type == 3">特定活动合作方</span>
                </template>
            </el-table-column>
            <!-- 分类类型  -->
            <el-table-column label="分类类型" prop="classificationType" align="center" :show-overflow-tooltip='true'
                width="150">
                <template #default="scope">
                    <span v-show="scope.row.classificationType == 1">平台分类</span>
                    <span v-show="scope.row.classificationType == 2">自有分类</span>
                </template>
            </el-table-column>
            <!-- 前端展示 -->
            <el-table-column label="前端展示" prop="shopState" align="center" :show-overflow-tooltip='true' width="150">
                <template #default="scope">
                    <el-tag type="success" v-show="scope.row.shopState == 1">展示</el-tag>
                    <el-tag type="warning" v-show="scope.row.shopState == 2">不展示</el-tag>
                </template>
            </el-table-column>
            <!-- 品牌图标 -->
            <el-table-column label="品牌图标" prop="brandImage" align="center" :show-overflow-tooltip='true' width="150">
                <template #default="scope">
                    <el-image style="width: 50px; height: 50px" :src="scope.row.brandImage" fit="cover"
                        :preview-src-list="[scope.row.brandImage]" preview-teleported hide-on-click-modal />
                </template>
            </el-table-column>
            <!-- 手机号列表  -->
            <el-table-column label="手机号列表 " prop="mobile" align="center" :show-overflow-tooltip='true' width="250">
            </el-table-column>
            <!-- 账号  -->
            <el-table-column label="账号 " prop="accountNumber" align="center" :show-overflow-tooltip='true' width="150">
            </el-table-column>
            <!-- 登录权限 -->
            <el-table-column label="登录权限" prop="state" align="center" :show-overflow-tooltip='true' width="150">
                <template #default="scope">
                    <el-tag type="success" v-show="scope.row.state == 1">允许</el-tag>
                    <el-tag type="danger" v-show="scope.row.state == 2">不允许</el-tag>
                </template>
            </el-table-column>
            <!-- 排序（大-小）  -->
            <el-table-column label="排序（大-小）" prop="sort" align="center" :show-overflow-tooltip='true' width="120">
            </el-table-column>
            <!-- 创建时间  -->
            <el-table-column label="创建时间 " prop="createTime" align="center" :show-overflow-tooltip='true' width="150"
                :formatter="reach">
            </el-table-column>
            <!-- 备注  -->
            <el-table-column label="备注 " prop="remarks" align="center" :show-overflow-tooltip='true' width="150">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作" align="center" width="150" :show-overflow-tooltip='true'>
                <template #default="scope">
                    <el-button size="default" class="bulur" @click="editPartner(scope.row.id)"><el-icon>
                            <EditPen />
                        </el-icon>编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script setup>
import { Plus, EditPen } from '@element-plus/icons-vue'
import useTable from '@/hooks/merchantManagement/useTable'
const { filterTableData, count, showLoading, reach, addPartner, editPartner } = useTable()

</script>
<style lang="scss" scoped>
.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.header_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.count {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}
</style>